import {
  SET_JOB_CONFIG_TEMPLATES
} from 'app/actions/types';

import {
  getJobConfigTemplates as getJobConfigTemplatesSvc
} from 'app/services/jobConfigTemplates';

export const getJobConfigTemplates = params => async dispatch => {
  let jobConfigTemplates = await getJobConfigTemplatesSvc(params);

  if (jobConfigTemplates) {
    dispatch({
      type: SET_JOB_CONFIG_TEMPLATES,
      payload: jobConfigTemplates.params
    });
  }

  return jobConfigTemplates;
}

export const setJobConfigTemplateParams = params => async dispatch => {
  dispatch({
    type: SET_JOB_CONFIG_TEMPLATES,
    payload: params
  });
}
